// Utils
import {
  ConvertUtility as Convert
} from './convert-utility'

export class ClientUtility {

  /**
   * Validate response object
   * @param {*} data      - Response Object
   * @param {String} key  - Key of Result
   * @returns {Boolean} Validate state
   */
  static has(data, key = 'result') {
    if (!data || typeof data !== 'object') return false
    return Object.keys(data).includes(key)
  }

  /**
   * Error response handler
   *
   * Always returns an object so callers can safely destructure
   * (e.g. `const { errorCode } = Client.error(...)`).
   * @param {String} action     - Action name
   * @param {import('axios').AxiosError} error  - Request error
   * @returns {Object} CamelCased response data, or `{}` when unavailable
   */
  static error(action, error) {

    if (!error) return {}

    const { response } = error

    if (!response) return {}

    const { data } = response

    if (data && typeof data === 'object') return Convert.key(data)

    return {}
  }

  /**
   * Domain error code from a request-validation failure. Those responses carry
   * only a generic errorCode (BAD_REQUEST); the backend puts the specific code
   * in the message list instead, prefixed with the property path for nested
   * payloads (e.g. `items.0.NONSC_HOME_AREA_INVALID` on bulk import).
   * @param {*} messages - Error response message
   * @returns {String|null} Domain error code
   */
  static reason(messages) {

    if (!Array.isArray(messages)) return null

    const code = /(?:^|\.)([A-Z][A-Z0-9_]+)$/

    const match = messages
      .map((e) => (typeof e === 'string' ? code.exec(e) : null))
      .find(Boolean)

    return match ? match[1] : null
  }
}
